import { ReactNode } from 'react';

/**
 * Will only be rendered when running in development mode locally.
 * Can be used for various debugging elements and other stuff we want to have in the app,
 * but don't want to show to the users when the actual app is built and deployed.
 */
export default function VisibleInDevelopment({
  children,
}: {
  children?: ReactNode;
}) {
  const isDevelopmentMode = process.env.NODE_ENV === 'development';

  if (!isDevelopmentMode) {
    return null;
  }

  return children as JSX.Element;
}
